import React from "react";

const SignupStepper = ({ activeStep }) => {
  return (
    <div className="signup-stepper">
      <div className={`step ${activeStep === 1 ? "active" : ""}`}>
        <div className="step-number">1</div>
        <span className="step-label">본인인증</span>
      </div>
      <span className="step-dots">••</span>
      <div className={`step ${activeStep === 2 ? "active" : ""}`}>
        <div className="step-number">2</div>
        <span className="step-label">회원 정보 입력</span>
      </div>
      <span className="step-dots">••</span>
      <div className={`step ${activeStep === 3 ? "active" : ""}`}>
        <div className="step-number">3</div>
        <span className="step-label">가입 완료</span>
      </div>
    </div>
  );
};

export default SignupStepper;
